import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Franchisee Staffs
import FranchiseeStaffIndexPage from "../views/franchisee-staffs/index.vue";
import FranchiseeStaffCreatePage from "../views/franchisee-staffs/create.vue";
import FranchiseeStaffIdPage from "../views/franchisee-staffs/id.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Outlets
import OutletsPage from "../views/outlets/index.vue";
import OutletCreatePage from "../views/outlets/create.vue";
import OutletIdPage from "../views/outlets/id.vue";
// import OutletsUploadPage from "../views/outlets/upload.vue";

// Outlet Users
import OutletUsersPage from "../views/outlets/outlet-users/index.vue";
import OutletUserCreatePage from "../views/outlets/outlet-users/create.vue";
import OutletUserIdPage from "../views/outlets/outlet-users/id.vue";

// Pjps
import PjpsPage from "../views/pjps/index.vue";
import PjpCreatePage from "../views/pjps/create.vue";
import PjpIdPage from "../views/pjps/id.vue";
import PjpsUploadPage from "../views/pjps/upload.vue";
import PjpCopyReferencesPage from "../views/pjps/copy-pjp-references.vue";
import PjpCopyPreviousMonth from "../views/pjps/copy-pjp-prev-month.vue";

// PjpReferences
import PjpReferencesPage from "../views/pjp-references/index.vue";
import PjpReferenceCreatePage from "../views/pjp-references/create.vue";
import PjpReferenceIdPage from "../views/pjp-references/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";

// Banners
import BannersPage from "../views/banners/index.vue";
import BannerCreatePage from "../views/banners/create.vue";
import BannerIdPage from "../views/banners/id.vue";
// Franchisees
import FranchiseesPage from "../views/franchisees/index.vue";
import FranchiseeCreatePage from "../views/franchisees/create.vue";
import FranchiseeIdPage from "../views/franchisees/id.vue";
// FranchiseeTimeSlots
import FranchiseeTimeSlotsPage from "../views/franchisee-time-slots/index.vue";
// PlanTimeSlots
import PlanTimeSlotsPage from "../views/plan-time-slots/index.vue";
// FranchiseeKycDocuments
import FranchiseeKycDocumentsPage from "../views/franchisee-kyc-documents/index.vue";
import FranchiseeKycDocumentIdPage from "../views/franchisee-kyc-documents/id.vue";
import FranchiseeKycDocumentResubmitPage from "../views/franchisee-kyc-documents/resubmit.vue";
// UserKycDocuments
import UserKycDocumentsPage from "../views/user-kyc-documents/index.vue";
import UserKycDocumentIdPage from "../views/user-kyc-documents/id.vue";
import UserKycDocumentResubmitPage from "../views/user-kyc-documents/resubmit.vue";
// Services
import ServicesPage from "../views/services/index.vue";
import ServiceCreatePage from "../views/services/create.vue";
import ServiceIdPage from "../views/services/id.vue";
// Contact Messages
import ContactMessagesPage from "../views/contact-messages/index.vue";
// Career Applications
import CareerApplicationsPage from "../views/career-applications/index.vue";
// PetWalkieCareerRequests
import PetWalkieCareerRequestsPage from "../views/pet-walkie-career-requests/index.vue";
import PetWalkieCareerRequestCreatePage from "../views/pet-walkie-career-requests/create.vue";
import PetWalkieCareerRequestIdPage from "../views/pet-walkie-career-requests/id.vue";
// PetTrainerCareerRequests
import PetTrainerCareerRequestsPage from "../views/pet-trainer-career-requests/index.vue";
import PetTrainerCareerRequestCreatePage from "../views/pet-trainer-career-requests/create.vue";
import PetTrainerCareerRequestIdPage from "../views/pet-trainer-career-requests/id.vue";
// FranchiseeCareerRequests
import FranchiseeCareerRequestsPage from "../views/franchisee-career-requests/index.vue";
import FranchiseeCareerRequestCreatePage from "../views/franchisee-career-requests/create.vue";
import FranchiseeCareerRequestIdPage from "../views/franchisee-career-requests/id.vue";
// DaycareCareerRequests
import DaycareCareerRequestsPage from "../views/daycare-career-requests/index.vue";
import DaycareCareerRequestCreatePage from "../views/daycare-career-requests/create.vue";
import DaycareCareerRequestIdPage from "../views/daycare-career-requests/id.vue";
// UserServiceInterests
import UserServiceInterestsPage from "../views/user-service-interests/index.vue";
// Plans
import PlansPage from "../views/plans/index.vue";
import PlanCreatePage from "../views/plans/create.vue";
import PlanIdPage from "../views/plans/id.vue";
// PlanZoneCommissions
import PlanZoneCommissionsPage from "../views/plans/zone-commissions/index.vue";
import PlanZoneCommissionCreatePage from "../views/plans/zone-commissions/create.vue";
import PlanZoneCommissionIdPage from "../views/plans/zone-commissions/id.vue";
import ZoneCommissionSettingsPage from "../views/zone-commission-settings/index.vue";
// Blogs
import BlogsPage from "../views/blogs/index.vue";
import BlogCreatePage from "../views/blogs/create.vue";
import BlogIdPage from "../views/blogs/id.vue";
// BlogDetails
import BlogDetailsPage from "../views/blogs/blog-details/index.vue";
import BlogDetailCreatePage from "../views/blogs/blog-details/create.vue";
import BlogDetailIdPage from "../views/blogs/blog-details/id.vue";
// Upcoming Services
import UpcomingServicesPage from "../views/upcoming-services/index.vue";
import UpcomingServiceCreatePage from "../views/upcoming-services/create.vue";
import UpcomingServiceIdPage from "../views/upcoming-services/id.vue";
// UserMonthlyJobRequests
import UserMonthlyJobRequestsPage from "../views/user-monthly-job-requests/index.vue";
// Payments
import PaymentsPage from "../views/payments/index.vue";
import UserMonthlyJobRequestCreatePage from "../views/user-monthly-job-requests/create.vue";
import UserMonthlyJobRequestIdPage from "../views/user-monthly-job-requests/id.vue";
// DailyJobPlans
import DailyJobPlansPage from "../views/daily-job-plans/index.vue";
import DailyJobPlanCreatePage from "../views/daily-job-plans/create.vue";
import DailyJobPlanIdPage from "../views/daily-job-plans/id.vue";
// RescheduleRequests
import RescheduleRequestsPage from "../views/leave-requests/index.vue";
import RescheduleRequestCreatePage from "../views/leave-requests/create.vue";
import RescheduleRequestIdPage from "../views/leave-requests/id.vue";
// StateHolidays
import StateHolidaysPage from "../views/state-holidays/index.vue";
import StateHolidayCreatePage from "../views/state-holidays/create.vue";
import StateHolidayIdPage from "../views/state-holidays/id.vue";
// StateGsts
import StateGstsPage from "../views/state-gsts/index.vue";
import StateGstCreatePage from "../views/state-gsts/create.vue";
import StateGstIdPage from "../views/state-gsts/id.vue";
// Reward Settings
import RewardSettingsPage from "../views/reward-settings/index.vue";

// Versions
import VersionsPage from "../views/versions/index.vue";

// Coupons
import CouponsPage from "../views/coupons/index.vue";
import CouponCreatePage from "../views/coupons/create.vue";
import CouponIdPage from "../views/coupons/id.vue";
import CouponUsagesPage from "../views/coupons/usages.vue";
// CustomerWalkRequests
import CustomerWalkRequestsPage from "../views/customer-walk-requests/index.vue";
// DeleteAccountRequest
import DeleteAccountRequestPage from "../views/delete-requests/create.vue";
import DeleteAccountRequestIndexPage from "../views/delete-requests/index.vue";
// PrivacyPolicy
import PrivacyPolicyPage from "../views/privacy-policy/index.vue";

const routes = [
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      {
        path: "/shortcuts",
        name: "ShortcutsPage",
        component: () => import("../views/home/shortcuts.vue"),
      },
      // Reports (access per role is enforced by the API)
      {
        path: "/reports",
        name: "ReportsPage",
        component: () => import("../views/walkies-reports/index.vue"),
      },
      {
        path: "/reports/dashboard",
        name: "ReportsDashboardPage",
        component: () => import("../views/walkies-reports/dashboard.vue"),
      },
      {
        path: "/action-dashboard",
        name: "ActionDashboardPage",
        component: () => import("../views/walkies-reports/action-dashboard.vue"),
      },
      {
        path: "/revenue-share",
        name: "RevenueSharePage",
        component: () => import("../views/walkies-reports/revenue-share.vue"),
      },
      {
        path: "/reports/:key",
        name: "ReportViewPage",
        component: () => import("../views/walkies-reports/view.vue"),
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "Users_Listing",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Outlets
      {
        path: "/outlets",
        name: "OutletsPage",
        component: OutletsPage,
      },
      // {
      //   path: "/outlets/upload",
      //   name: "OutletsUploadPage",
      //   component: OutletsUploadPage,
      // },
      {
        path: "/outlets/create",
        name: "OutletCreatePage",
        component: OutletCreatePage,
      },
      {
        path: "/outlets/:outletId",
        name: "OutletIdPage",
        component: OutletIdPage,
      },
      // OutletUsers
      {
        path: "/outlets/:outletId/outlet-users",
        name: "OutletUsersPage",
        component: OutletUsersPage,
      },
      {
        path: "/outlets/:outletId/outlet-users/create",
        name: "OutletUserCreatePage",
        component: OutletUserCreatePage,
      },
      {
        path: "/outlet-users/:outletUserId",
        name: "OutletUserIdPage",
        component: OutletUserIdPage,
      },
      // Pjps
      {
        path: "/pjps",
        name: "PjpsPage",
        component: PjpsPage,
      },
      {
        path: "/pjps/upload",
        name: "PjpsUploadPage",
        component: PjpsUploadPage,
      },
      {
        path: "/pjps/copy-pjp-references",
        name: "PjpCopyReferencesPage",
        component: PjpCopyReferencesPage,
      },
      {
        path: "/pjps/copy-pjp-prev-month",
        name: "PjpCopyPreviousMonth",
        component: PjpCopyPreviousMonth,
      },
      {
        path: "/pjps/create",
        name: "PjpCreatePage",
        component: PjpCreatePage,
      },
      {
        path: "/pjps/:pjpId",
        name: "PjpIdPage",
        component: PjpIdPage,
      },
      // PjpReferences
      {
        path: "/pjp-references",
        name: "PjpReferencesPage",
        component: PjpReferencesPage,
      },
      {
        path: "/pjp-references/create",
        name: "PjpReferenceCreatePage",
        component: PjpReferenceCreatePage,
      },
      {
        path: "/pjp-references/:pjpReferenceId",
        name: "PjpReferenceIdPage",
        component: PjpReferenceIdPage,
      },
      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
      },
      // Banners
      {
        path: "/banners",
        name: "BannersPage",
        component: BannersPage,
      },
      {
        path: "/banners/create",
        name: "BannerCreatePage",
        component: BannerCreatePage,
      },
      {
        path: "/banners/:bannerId",
        name: "BannerIdPage",
        component: BannerIdPage,
      },
      // Franchisees
      {
        path: "/franchisees",
        name: "FranchiseesPage",
        component: FranchiseesPage,
      },
      // Master Franchisees
      {
        path: "/master-franchisees",
        name: "MasterFranchiseesPage",
        component: () => import("../views/master-franchisees/index.vue"),
      },
      {
        path: "/master-franchisees/create",
        name: "MasterFranchiseeCreatePage",
        component: () => import("../views/master-franchisees/create.vue"),
      },
      {
        path: "/master-franchisees/:masterFranchiseeId",
        name: "MasterFranchiseeEditPage",
        component: () => import("../views/master-franchisees/id.vue"),
      },
      {
        path: "/franchisees/create",
        name: "FranchiseeCreatePage",
        component: FranchiseeCreatePage,
      },
      {
        path: "/franchisees/:franchiseeId",
        name: "FranchiseeIdPage",
        component: FranchiseeIdPage,
      },
      {
        path: "/franchisee-staffs",
        name: "Franchisee_Staff_Listing",
        component: FranchiseeStaffIndexPage,
      },
      {
        path: "/franchisee-staffs/create",
        name: "Franchisee_Staff_Create",
        component: FranchiseeStaffCreatePage,
      },
      {
        path: "/franchisee-staffs/:id",
        name: "Franchisee_Staff_Edit",
        component: FranchiseeStaffIdPage,
      },
      {
        path: "/franchisee-time-slots",
        name: "FranchiseeTimeSlotsPage",
        component: FranchiseeTimeSlotsPage,
      },
      {
        path: "/plan-time-slots",
        name: "PlanTimeSlotsPage",
        component: PlanTimeSlotsPage,
      },
      {
        path: "/franchisee-kyc-documents",
        name: "FranchiseeKycDocumentsPage",
        component: FranchiseeKycDocumentsPage,
      },
      {
        path: "/franchisee-kyc-documents/:franchiseeKycDocumentId",
        name: "FranchiseeKycDocumentIdPage",
        component: FranchiseeKycDocumentIdPage,
      },
      {
        path: "/franchisee-kyc-documents/re-submit/:franchiseeKycDocumentId",
        name: "FranchiseeKycDocumentResubmitPage",
        component: FranchiseeKycDocumentResubmitPage,
      },
      {
        path: "/user-kyc-documents",
        name: "UserKycDocumentsPage",
        component: UserKycDocumentsPage,
      },
      {
        path: "/user-kyc-documents/:userKycDocumentId",
        name: "UserKycDocumentIdPage",
        component: UserKycDocumentIdPage,
      },
      {
        path: "/user-kyc-documents/re-submit/:userKycDocumentId",
        name: "UserKycDocumentResubmitPage",
        component: UserKycDocumentResubmitPage,
      },
      // Services
      {
        path: "/services",
        name: "ServicesPage",
        component: ServicesPage,
      },
      {
        path: "/services/create",
        name: "ServiceCreatePage",
        component: ServiceCreatePage,
      },
      {
        path: "/services/:serviceId",
        name: "ServiceIdPage",
        component: ServiceIdPage,
      },
      // Contact Messages
      {
        path: "/contact-messages",
        name: "ContactMessagesPage",
        component: ContactMessagesPage,
      },
      // Career Applications
      {
        path: "/career-applications",
        name: "CareerApplicationsPage",
        component: CareerApplicationsPage,
      },
      // PetWalkieCareerRequests
      {
        path: "/pet-walkie-career-requests",
        name: "PetWalkieCareerRequestsPage",
        component: PetWalkieCareerRequestsPage,
      },
      {
        path: "/pet-walkie-career-requests/create",
        name: "PetWalkieCareerRequestCreatePage",
        component: PetWalkieCareerRequestCreatePage,
      },
      {
        path: "/pet-walkie-career-requests/:petWalkieCareerRequestId",
        name: "PetWalkieCareerRequestIdPage",
        component: PetWalkieCareerRequestIdPage,
      },
      // PetTrainerCareerRequests
      {
        path: "/pet-trainer-career-requests",
        name: "PetTrainerCareerRequestsPage",
        component: PetTrainerCareerRequestsPage,
      },
      {
        path: "/pet-trainer-career-requests/create",
        name: "PetTrainerCareerRequestCreatePage",
        component: PetTrainerCareerRequestCreatePage,
      },
      {
        path: "/pet-trainer-career-requests/:petTrainerCareerRequestId",
        name: "PetTrainerCareerRequestIdPage",
        component: PetTrainerCareerRequestIdPage,
      },
      // FranchiseeCareerRequests
      {
        path: "/franchisee-career-requests",
        name: "FranchiseeCareerRequestsPage",
        component: FranchiseeCareerRequestsPage,
      },
      {
        path: "/franchisee-career-requests/create",
        name: "FranchiseeCareerRequestCreatePage",
        component: FranchiseeCareerRequestCreatePage,
      },
      {
        path: "/franchisee-career-requests/:franchiseeCareerRequestId",
        name: "FranchiseeCareerRequestIdPage",
        component: FranchiseeCareerRequestIdPage,
      },
      // DaycareCareerRequests
      {
        path: "/daycare-career-requests",
        name: "DaycareCareerRequestsPage",
        component: DaycareCareerRequestsPage,
      },
      {
        path: "/daycare-career-requests/create",
        name: "DaycareCareerRequestCreatePage",
        component: DaycareCareerRequestCreatePage,
      },
      {
        path: "/daycare-career-requests/:petTrainerCareerRequestId",
        name: "DaycareCareerRequestIdPage",
        component: DaycareCareerRequestIdPage,
      },
      // Plans
      {
        path: "/plans",
        name: "PlansPage",
        component: PlansPage,
      },
      {
        path: "/plans/create",
        name: "PlanCreatePage",
        component: PlanCreatePage,
      },
      {
        path: "/plans/:planId",
        name: "PlanIdPage",
        component: PlanIdPage,
      },
      // PlanZoneCommissions
      {
        path: "/plans/:planId/zone-commissions",
        name: "PlanZoneCommissionsPage",
        component: PlanZoneCommissionsPage,
      },
      {
        path: "/plans/:planId/zone-commissions/create",
        name: "PlanZoneCommissionCreatePage",
        component: PlanZoneCommissionCreatePage,
      },
      {
        path: "/zone-commission-settings",
        name: "ZoneCommissionSettingsPage",
        component: ZoneCommissionSettingsPage,
      },
      { path: "/bulk-zone-commissions", redirect: "/zone-commission-settings" },
      {
        path: "/zone-commissions/:planZoneCommissionId",
        name: "PlanZoneCommissionIdPage",
        component: PlanZoneCommissionIdPage,
      },
      // UserServiceInterests
      {
        path: "/upcoming-services/:upcomingServiceId/user-service-interests",
        name: "UserServiceInterestsPage",
        component: UserServiceInterestsPage,
      },
      // UserMonthlyJobRequests
      {
        path: "/user-monthly-job-requests",
        name: "UserMonthlyJobRequestsPage",
        component: UserMonthlyJobRequestsPage,
      },
      // Payments
      {
        path: "/payments",
        name: "PaymentsPage",
        component: PaymentsPage,
      },
      {
        path: "/user-monthly-job-requests/create",
        name: "UserMonthlyJobRequestCreatePage",
        component: UserMonthlyJobRequestCreatePage,
      },
      {
        path: "/user-monthly-job-requests/:userMonthlyJobRequestId",
        name: "UserMonthlyJobRequestIdPage",
        component: UserMonthlyJobRequestIdPage,
      },
      // DailyJobPlans
      {
        path: "/daily-job-plans",
        name: "DailyJobPlansPage",
        component: DailyJobPlansPage,
      },
      {
        path: "/daily-job-plans/create",
        name: "DailyJobPlanCreatePage",
        component: DailyJobPlanCreatePage,
      },
      {
        path: "/daily-job-plans/:dailyJobPlanId",
        name: "DailyJobPlanIdPage",
        component: DailyJobPlanIdPage,
      },
      // CustomerWalkRequests
      {
        path: "/customer-walk-requests",
        name: "CustomerWalkRequestsPage",
        component: CustomerWalkRequestsPage,
      },
      // RescheduleRequests
      {
        path: "/leave-requests",
        name: "RescheduleRequestsPage",
        component: RescheduleRequestsPage,
      },
      {
        path: "/leave-requests/create",
        name: "RescheduleRequestCreatePage",
        component: RescheduleRequestCreatePage,
      },
      {
        path: "/leave-requests/:dailyJobPlanId",
        name: "RescheduleRequestIdPage",
        component: RescheduleRequestIdPage,
      },
      // StateHolidays
      {
        path: "/state-holidays",
        name: "StateHolidaysPage",
        component: StateHolidaysPage,
      },
      {
        path: "/state-holidays/create",
        name: "StateHolidayCreatePage",
        component: StateHolidayCreatePage,
      },
      {
        path: "/state-holidays/:stateHolidayId",
        name: "StateHolidayIdPage",
        component: StateHolidayIdPage,
      },
      // StateGsts
      {
        path: "/state-gsts",
        name: "StateGstsPage",
        component: StateGstsPage,
      },
      {
        path: "/state-gsts/create",
        name: "StateGstCreatePage",
        component: StateGstCreatePage,
      },
      {
        path: "/state-gsts/:stateGstId",
        name: "StateGstIdPage",
        component: StateGstIdPage,
      },
      // Reward Settings
      {
        path: "/reward-settings",
        name: "RewardSettingsPage",
        component: RewardSettingsPage,
      },
      // Versions
      {
        path: "/versions",
        name: "VersionsPage",
        component: VersionsPage,
      },
      // Coupons
      {
        path: "/coupons",
        name: "CouponsPage",
        component: CouponsPage,
      },
      {
        path: "/coupons/create",
        name: "CouponCreatePage",
        component: CouponCreatePage,
      },
      {
        path: "/coupons/:couponId/usages",
        name: "CouponUsagesPage",
        component: CouponUsagesPage,
      },
      {
        path: "/coupons/:couponId",
        name: "CouponIdPage",
        component: CouponIdPage,
      },
      // Blogs
      {
        path: "/blogs",
        name: "BlogsPage",
        component: BlogsPage,
      },
      {
        path: "/blogs/create",
        name: "BlogCreatePage",
        component: BlogCreatePage,
      },
      {
        path: "/blogs/:blogId",
        name: "BlogIdPage",
        component: BlogIdPage,
      },
      // Blogs
      {
        path: "/blogs/:blogId/blog-details",
        name: "BlogDetailsPage",
        component: BlogDetailsPage,
      },
      {
        path: "/blogs/:blogId/blog-details/create",
        name: "BlogDetailCreatePage",
        component: BlogDetailCreatePage,
      },
      {
        path: "/blog-details/:blogDetailId",
        name: "BlogDetailIdPage",
        component: BlogDetailIdPage,
      },
      // Upcoming Services
      {
        path: "/upcoming-services",
        name: "UpcomingServicesPage",
        component: UpcomingServicesPage,
      },
      {
        path: "/upcoming-services/create",
        name: "UpcomingServiceCreatePage",
        component: UpcomingServiceCreatePage,
      },
      {
        path: "/upcoming-services/:upcomingServiceId",
        name: "UpcomingServiceIdPage",
        component: UpcomingServiceIdPage,
      },
      // Delete Account
      {
        path: "/account-delete-request/create",
        name: "DeleteAccountRequestPage",
        component: DeleteAccountRequestPage,
      },
      {
        path: "/account-delete-request",
        name: "DeleteAccountRequestIndexPage",
        component: DeleteAccountRequestIndexPage,
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
      {
        path: "/account-delete-request/create",
        name: "PublicDeleteAccountRequestPage",
        component: DeleteAccountRequestPage,
      },
      {
        path: "/privacy-policy",
        name: "PrivacyPolicyPage",
        component: PrivacyPolicyPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "PublicDeleteAccountRequestPage" ||
    to.name === "ForgotPasswordPage" ||
    to.name === "PrivacyPolicyPage"
  ) {
    console.log("1");
    if (store.getters["auth/authenticated"]) {
      console.log("2");
      let company_id = store.getters["auth/company"].id;
      if (company_id) {
        console.log("3");
        console.log(company_id);
      }
      return next({
        name: "HomePage",
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("4");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("5");
    return next({
      name: "HomePage",
    });
  }
  next();
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`,
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
